import { makeApi } from "@zodios/core";
import { z } from "zod";

import { GenerationErrorResponse } from "../response.ts";

export const QuestionAnswer = z.object({
  answer: z.string().describe("A possible answer to the posed question"),
  correct: z.boolean().describe("Whether the answer is correct or not"),
  rating: z.number().describe("Correctness rating from 0 to 100"),
});

export type QuestionAnswer = z.infer<typeof QuestionAnswer>;

export const QuestionAnswers = z.object({
  questionAnswers: z
    .array(QuestionAnswer)
    .describe("A list of question answers based on the posed question")
    .default([]),
});

export type QuestionAnswers = z.infer<typeof QuestionAnswers>;

export const questionAnswersApi = makeApi([
  {
    method: "get",
    path: "/copilot/questions/list",
    alias: "getQuestionAnswers",
    parameters: [
      {
        type: "Query",
        name: "question",
        schema: z.string(),
      },
      {
        type: "Query",
        name: "additionalContext",
        schema: z.string().optional(),
      },
    ],
    response: QuestionAnswers,
    errors: [
      { status: 400, schema: GenerationErrorResponse },
      { status: 401, schema: z.string() },
    ],
  },
]);
